import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersBatchManagementVM } from 'system/view-models/batch-managment/filters-vm';

export const initialValuesBatchManagement: FiltersBatchManagementVM = {
  batchName: '',
  batchDescription: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageBatchManagement = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesBatchManagement}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageBatchManagement.displayName = 'Page batch management initializer component';

export default PageBatchManagement;
